import { connect } from 'react-redux';
import Trending from './Trending';

const mapStateToProps = ({ content: { trending }, renderOptions: { showTrendingModal }}) => ({
  tiles: trending,
  showTrendingModal
});

export default connect(mapStateToProps)(Trending);
